<div class="footer-div" *ngIf="htmlContent" [innerHTML]="htmlContent">
</div>
